module.exports = __webpack_public_path__ + "img/02.398cd4c7.png";